import AmbryItem from "../AmbryItem";
import LotteryFFCItem from "./LotteryFFCItem";
import LotteryFFCManager from "./LotteryFFCManager";

const {ccclass, property} = cc._decorator;
/**
 *
 * 分分彩预制体
 */
@ccclass
export default class LotteryFFCPrefab extends cc.Component {

    @property({type:cc.Prefab,displayName:"分分彩历史预制体"})
    ffcHistoryPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"分分彩Item预制体"})
    ffcItemPrefab : cc.Prefab = null;

    @property(cc.Node)
    contentNode : cc.Node = null;
    @property({type:cc.Sprite,displayName:"上一次的开奖结果"})
    lastPrizeIcon : cc.Sprite = null;
    @property({type:cc.Label,displayName:"倒计时"})
    lbDownTown : cc.Label = null;

    private mLotteryFFCManager : LotteryFFCManager;
    onLoad () {}

    start () {

    }

    bindData( lotteryFFCManager : LotteryFFCManager ){
        this.mLotteryFFCManager = lotteryFFCManager;
        this.initData();
    }

    initData(){
        // for ( let chineseZodiac of this.mLotteryFFCManager.ChineseZodiacArray ) {
        //     // 初始化橱柜
        //     let ffcItemPrefab = cc.instantiate( this.ffcItemPrefab );
        //     ffcItemPrefab.getComponent( LotteryFFCItem ).bindData( chineseZodiac , this.mLotteryFFCManager );
        //     this.contentNode.addChild( ffcItemPrefab );
        // }
    }

    /**
     * 直接退出
     */
    onBtnExit(){
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 打开开奖历史
     */
    onBtnOpenHistory(){
        let ffcHistoryNode = cc.instantiate( this.ffcHistoryPrefab );
        this.node.addChild( ffcHistoryNode );
    }

}
